// @ts-check

/**
 * @typedef {"development" | "e2"} DevelopmentBuilds
 */

/**
 * @typedef {"online" | "onlineSelective" | "freeze" | "e2" | null} ProductionBuilds
 */

/**
 * @typedef {"staging" | "stage1" | "stage2" | "stage3" | "stage4"} Stages
 */

/**
 * @typedef {Object} GameType
 * @property {string} name
 * @property {string} id
 * @property {string=} originalId  // don't use if you don't fully understand, it's a special case for old gs
 * @property {string=} customBuild
 * @property {string=} frozenBuild
 * @property {DevelopmentBuilds | ProductionBuilds} staging
 * @property {ProductionBuilds} stage1
 * @property {ProductionBuilds} stage2
 * @property {ProductionBuilds} stage3
 * @property {ProductionBuilds} stage4
 */

/**
 * @typedef {GameType[]} GameListType
 */

/**
 * @param {string} value
 * @returns {value is Stages} True if value is a valid stage
 */
export function isCorrectStageValue(value) {
    return ["development", "staging", "stage1", "stage2", "stage3", "stage4"].includes(value);
}